export const api = {
  host: 'https://wonderchef.api.flowsmart.ai'
};
